export class CustomError extends Error {};

class ErrorGenerator {
  createApiErrorClass(msg, statusCode) {
    return class extends CustomError {
      constructor() {
        super();
        this.msg = msg;
        this.statusCode = statusCode;
      }
    };
  }
}

const errorGenerator = new ErrorGenerator();
export default errorGenerator;